import { autoinject, bindable } from 'aurelia-framework';
import { ICustomer } from '../../customers/customer-service';
import { IScopeAM, IScopePlainAM } from '../../scopes/scope-service';

@autoinject
export class DataCopy {

	@bindable scope: IScopePlainAM;
	@bindable sourceCustomers: ICustomer[];
	@bindable selectedCustomerId: string;
	@bindable changeSelectedCustomer: (params: { id: string }) => void;
	@bindable targetCustomerId: string;

	@bindable sourceScopes: IScopeAM[]
	@bindable selectedScopeId: string;
	@bindable changeSelectedScope: (params: { id: string }) => void;
	@bindable submit: (params: { financialEntrySourceFilter: string, keepServiceTargeting: string }) => void;

	@bindable isAboutFinancialEntries: boolean;
	financialEntrySourceFilter: string = 'All';

	@bindable keepServiceTargeting: boolean = false;

	get isKeepServiceTargetingDisabled() {
		if (this.financialEntrySourceFilter == 'Original') {
			this.keepServiceTargeting = false;
		}
		return this.financialEntrySourceFilter == 'Original';
	}

	constructor() { }
}
